import { render, staticRenderFns } from "./TagFields.vue?vue&type=template&id=34c08e9a"
import script from "./TagFields.vue?vue&type=script&lang=js"
export * from "./TagFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports